import React, {Component} from "react";
import {reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormError from "../../components/forms/FormError";

class InviteCustomerForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>This will send an invitation email to the customer to verify their details to gain access to their account. <strong>Please note:</strong> when using this method, please ensure that the customer has an account already setup.</p>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "InviteCustomerForm"
})(InviteCustomerForm);

export default ReduxForm;